module.exports = __webpack_public_path__ + "media/images/icons/twotone/alert-d047bae22b5965db749f1ae6c4bb1f93.svg";